import { FluentProvider } from "@/dependencies";
import { Spinner, SpinnerProps } from "@fluentui/react-components";

interface SpinnerCustomProps {
  rcName?: string;
  theme?: string;
}

const SpinnerCustom = (props: SpinnerCustomProps & SpinnerProps) => {
  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Spinner {...props} />
    </FluentProvider>
  ) : (
    <Spinner {...props} />
  );
};

export default SpinnerCustom;
